// extracted by mini-css-extract-plugin
export default {"whiteBox":"CommentInputContainer_whiteBox__CBPGo"};